import { Heart, ShieldOff, MessageSquareWarning, Ban, Compass, Handshake, Lock, Gavel } from "lucide-react";

export const RULES = [
  { icon: Heart, title: "Be respectful & kind", text: "Treat every collector the way you'd want to be treated. We're all here because we love this hobby." },
  { icon: ShieldOff, title: "No harassment or belittling", text: "No bullying, personal attacks, name-calling, or making anyone feel small. Disagree with ideas, never demean people." },
  { icon: MessageSquareWarning, title: "Keep it clean", text: "No profanity, hate speech, slurs, or sexually explicit or otherwise offensive content." },
  { icon: Ban, title: "No spam or scams", text: "No spam, chain messages, phishing, or unsolicited advertising outside the proper ad channels." },
  { icon: Compass, title: "Stay on topic", text: "Keep forum discussions about insulators, collecting, identification, and trading." },
  { icon: Handshake, title: "Trade honestly", text: "Describe pieces and their condition accurately. Represent grades, damage, and prices truthfully." },
  { icon: Lock, title: "Respect privacy", text: "Don't share anyone's personal information, private messages, or photos without permission." },
  { icon: Gavel, title: "Moderation", text: "Admins may edit or remove content and may suspend or permanently delete accounts that violate these rules. Repeated or serious violations — including belittling other members — can result in removal without warning." },
];

export function RulesContent({ compact = false }) {
  return (
    <div className={compact ? "space-y-3" : "space-y-4"} data-testid="rules-content">
      {RULES.map((r) => (
        <div key={r.title} className="flex items-start gap-3">
          <span className="w-9 h-9 rounded-lg grid place-items-center shrink-0" style={{ background: "var(--honey-100)" }}>
            <r.icon className="w-[18px] h-[18px]" style={{ color: "var(--honey-800)" }} />
          </span>
          <div>
            <h3 className="font-display text-lg font-bold leading-tight">{r.title}</h3>
            <p className={`text-muted-page ${compact ? "text-sm" : ""}`}>{r.text}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
